export default __webpack_public_path__ + "static/media/3a52c00be0b740fd84fa32f57aed5964.612a0943.md";